import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-consumer-punch-card-terms',
  templateUrl: 'consumer-punch-card-terms.html',
})
export class ConsumerPunchCardTermsPage {
	punchCard: any;
	terms: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  	this.punchCard = navParams.get('punchCard');
  	this.terms = navParams.get('terms');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerPunchCardTermsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/consumer-punch-card-terms/consumer-punch-card-terms.ts